<template>
	<Popup
		v-model="showPopup"
		position="bottom"
		class="popupBox"
		v-if="snapshot"
		@click-overlay="handleShowPopup"
		:close-on-click-overlay="false"
		round
		get-container="body"
	>
		<span class="closebtn" @click="handleShowPopup"></span>
		<StockInfoHeader :snapshot="snapshot" />
		<div class="stock-info">
			<div class="stock-info-left">
				<p class="stock-price" :style="computedStockColorByLang(snapshot.change)">
					<span v-html="computedClosePrice(snapshot.closePrice)"></span>
				</p>
				<div class="stock-price-more" :style="computedStockColorByLang(snapshot.change)">
					<p>{{ snapshot.change > 0 ? '+' : '' }}{{ stockColTransferUnit(snapshot.change) }}</p>
					<p>{{ snapshot.change > 0 ? '+' : '' }}{{ stockColTransferUnit(snapshot.changePct) }}%</p>
				</div>
			</div>
			<div class="stock-info-right">
				<ul>
					<li>
						{{ $t('enterprise.high')
						}}<span class="info-span">{{ stockColTransferUnit(snapshot.highPrice) }}</span>
					</li>
					<li>
						{{ $t('enterprise.low')
						}}<span class="info-span">{{ stockColTransferUnit(snapshot.lowPrice) }}</span>
					</li>
					<li>
						{{ $t('enterprise.P/E') }}<span class="info-span">{{ ttmFilter(snapshot.peTtm) }}</span>
					</li>
					<li>
						{{ $t('enterprise.P/B') }}<span class="info-span">{{ stockColTransferUnit(snapshot.pb) }}</span>
					</li>
				</ul>
				<ul>
					<li>
						{{ $t('enterprise.turnover')
						}}<span class="info-span">{{ stockColTransferUnit(snapshot.turnoverValue) }}</span>
					</li>
					<li>
						{{ $t('enterprise.volume') }}<span class="info-span">{{ computedVolume(snapshot) }}</span>
					</li>
					<li>
						{{ $t('enterprise.market-cap')
						}}<span class="info-span">{{ stockColTransferUnit(snapshot.totalMv) }}</span>
					</li>
					<li>
						{{ $t('enterprise.float-cap')
						}}<span class="info-span">{{ stockColTransferUnit(snapshot.negotiableMv) }}</span>
					</li>
				</ul>
			</div>
		</div>
	</Popup>
</template>

<script setup>
import StockInfoHeader from './StockInfoHeader.vue';
import { ref, defineExpose } from 'vue';
import { Popup } from 'vant';
import { computedStockColorByLang } from '@/assets/js/i18n';
import { useStockVO } from '@rebuild/hooks/useStockVO';

// 定义props
const props = defineProps({
	snapshot: {
		type: Object,
		default() {
			return {};
		}
	}
});

const showPopup = ref(false);

const handleShowPopup = () => {
	showPopup.value = !showPopup.value;
};

const { stockColTransferUnit, computedClosePrice, ttmFilter, computedVolume } = useStockVO();

defineExpose({
	handleShowPopup
});
</script>

<style lang="less" scoped>
@import '@rebuild/views/styles/container_base.less';

.popupBox {
	min-height: 2rem;
	padding: 0.35rem 0.14rem 0;
	font-family: 'PingFang SC';

	.center-750();
	left: 0;
	right: 0;

	.closebtn {
		position: absolute;
		width: 0.48rem;
		height: 0.03rem;
		left: 50%;
		top: 0.1rem;
		background: #d7d7d7;
		border-radius: 0.25rem;
		transform: translate(-50%, 0);
	}
}

.stock-title {
	color: #333;
	font-family: PingFang SC;
	font-size: 0.16rem;
	font-style: normal;
	font-weight: 500;
	line-height: 0.18rem; /* 112.5% */
	span {
		font-weight: 500;
		font-size: 0.12rem;
	}
}

.stock-date {
	margin-top: 0.06rem;
	color: #999;
	font-family: PingFang SC;
	font-size: 0.11rem;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.stock-price {
	font-family: 'DIN Alternate';
	font-size: 0.32rem;
	font-style: normal;
	font-weight: 700;
	line-height: 0.28rem; /* 87.5% */

	&-more {
		margin-top: 0.12rem;

		p {
			font-family: PingFang SC;
			font-size: 0.12rem;
			font-style: normal;
			font-weight: 500;
			line-height: 0.12rem; /* 100% */
		}
		p + p {
			margin-top: 0.08rem;
		}
	}
}

.stock-info {
	display: flex;
	margin: 0.17rem 0;
	.stock-info-left {
		flex: none;
		margin-right: 0.25rem;
	}
	.stock-info-right {
		flex: 1;
		width: 0;
		display: flex;
		font-size: 0.12rem;
		ul {
			flex: 50%;

			li {
				display: flex;
				justify-content: space-between;
				font-size: 0.12rem;
				line-height: 1.2;
				color: #666;
				.info-span {
					word-break: keep-all;
					color: #333;
				}
			}
			li + li {
				margin-top: 0.08rem;
			}
		}
		ul + ul {
			margin-left: 0.29rem;
		}
	}
}

@media screen and (max-width: 280px) {
	.stock-info-right {
		ul + ul {
			margin-left: 0.1rem !important;
		}
	}
}
</style>
